import { useContext } from "react";
import { FormatDateForDisplay, GetCurrentDate } from "../util/data-utils";
import { Button, ButtonToolbar } from "react-bootstrap";
import { ReviewContext } from "../Dashboard/ReviewPatient";
import { NavigationProps, WeightNavigationProps } from "../types/navigation";
import { SkipNextOutlined, SkipPreviousOutlined } from "@mui/icons-material";

interface TypeKeyProp {
  typeKey: string;
}

const DataNavigator = ({ typeKey }: TypeKeyProp) => {

  const context = useContext(ReviewContext);

  const getProps = () => {
    if(typeKey === "weight")
      return WeightNavigationProps;
    return NavigationProps;
  }

  var today = GetCurrentDate();
  var props = getProps();

  function clickBackward() {
    var newEnding = new Date(new Date(context.weekEnding).getTime() - props.timePeriodInDays * 24 * 3600 * 1000)
        .toISOString()
        .slice(0, 10);
    context.moreData(newEnding);
    context.weekEnding = newEnding;
  }

  function clickForward() {
    var newEnding = new Date(new Date(context.weekEnding).getTime() + props.timePeriodInDays * 24 * 3600 * 1000)
        .toISOString()
        .slice(0, 10);
    context.moreData(newEnding);
    context.weekEnding = newEnding;
  }

  return (
    <ButtonToolbar>
      <span className="me-2">{props.title} {FormatDateForDisplay(context.weekEnding)}</span>
      <Button className="btn-color me-2" onClick={clickBackward}>
        <SkipPreviousOutlined />
      </Button>
      <Button className="btn-color" onClick={clickForward} disabled={context.weekEnding === today}>
        <SkipNextOutlined />
      </Button>
    </ButtonToolbar>
  );
};

export default DataNavigator;
